import { API } from '../../config/api/index';

//ALL TYPE WISE DATA RETURN
const initState = {
    loading: false,
    invoiceData: {},
    vehicleList: {},
    invoiceDetails: {},
    newInvoice: {},
    customerList: {},
    advisorList: [],
    technicianList: [],
    feesList: [],
    multipleRecordPaymentList: {},
};

//DEFINE ACCOUNT REDUCER FUNCTION
const InvoiceReducer = (state = initState, action) => {
    switch (action.type) {
        case API.invoice.invoiceList:
            return {
                ...state,
                invoiceData: action.InvoiceData,
                loading: action.loading,
            };
        case API.invoice.vehicleList:
            return {
                ...state,
                vehicleList: action.vehicleList,
                loading: action.loading,
            };
        case API.invoice.invoiceDetails:
            return {
                ...state,
                invoiceDetails: action.invoiceDetails,
                loading: action.loading,
            };
        case API.invoice.create:
            return {
                ...state,
                newInvoice: action.newInvoice,
                loading: action.loading,
            };
        case API.invoice.customerList:
            return {
                ...state,
                customerList: action.customerList,
                loading: action.loading,
            };

        case API.inventory.advisor.get:
            return {
                ...state,
                advisorList: action.advisorList,
            };

        case API.inventory.technician.get:
            return {
                ...state,
                technicianList: action.technicianList,
            };
        case API.invoice.fees.list:
            return {
                ...state,
                feesList: action.feesList,
            };

        case API.invoice.multipleRecordPayment.list:
            return {
                ...state,
                multipleRecordPaymentList: action.multipleRecordPaymentList,
            };

        default:
            return state;
    }
};

//EXPORT ALL FUNCTION
export default InvoiceReducer;
